import { formatDateAndTime } from '../../../utils/formatDateTime';

/**
 * Display formatters for the Creator Program.
 *
 * The repo has no shared currency formatter (8 file-local copies). This uses the
 * exact-value form from `Admin/MerchantEarningsOverview/index.tsx` rather than the
 * abbreviated $1.2K/$3.4M variant in `Analytics/MerchantAnalytics/Constant.ts` —
 * payout ledgers need exact amounts. Money fields arrive as plain dollars, already
 * rounded to 2 decimals server-side (docs §6).
 */

export const formatCurrency = (amount?: number | null): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount ?? 0);

export const formatPercentage = (value?: number | null): string =>
  `${(value ?? 0).toFixed(1)}%`;

export const formatCount = (value?: number | null): string =>
  (value ?? 0).toLocaleString();

/** Share of `part` within `total`, guarded against a zero denominator. */
export const percentOf = (part?: number | null, total?: number | null): number => {
  const denominator = total ?? 0;
  if (denominator === 0) return 0;
  return ((part ?? 0) / denominator) * 100;
};

/** Em dash for a missing date, so every table renders the same placeholder. */
export const EMPTY_VALUE = '—';

/** An ISO timestamp as a plain date, or `—` when absent. */
export const formatDate = (iso?: string | null): string =>
  iso ? formatDateAndTime(iso).formattedDate : EMPTY_VALUE;
